import mediaVersions from './media-versions.json';
import { sampleMediaId } from './sample-media';
import type { SocialLayout } from '../../../../renderer/src/social-presentation';

/** Shared pacing for the curated video assets and interactive composition. */
export const SAMPLE_DURATION_SECONDS = 30;
export const SAMPLE_SECTION_LABEL = '4.71-mile route section';
export const SAMPLE_UNIT_SYSTEM = 'imperial' as const;
export const SAMPLE_OVERLAY_OPACITY = 45;
export const MAP_SAMPLE_PRESET = 'social-4x5' as const;
export const MAP_SAMPLE_LAYOUT = 'side-rail' as const;
export const MAP_SAMPLE_LAYOUTS: Readonly<Record<string, SocialLayout>> = {
  mcnally: 'information-card', positron: 'side-rail', relief: 'side-rail', topographic: 'side-rail',
  heat: 'top-title', 'moon-base': 'lower-title', terra: 'side-rail', blackbird: 'information-card',
};
export const mapSampleLayout = (map: string): SocialLayout => MAP_SAMPLE_LAYOUTS[map] ?? MAP_SAMPLE_LAYOUT;
export const samplePrepared = (id: string) => !!(mediaVersions as Record<string, string>)[sampleMediaId(id)];
/** Content hashes invalidate previously cached footage when a curated file changes. */
export function sampleVideoUrl(id: string) {
  const mediaId = sampleMediaId(id);
  const version = (mediaVersions as Record<string, string>)[mediaId];
  if (!version) throw new Error(`Missing prepared public sample: ${id}`);
  return `/samples/${mediaId}.mp4?v=${version}`;
}
